module.exports = __webpack_public_path__ + "b2875f9007eb64b42982560411716def.pdf";